import { render } from "./ProductLinker.vue?vue&type=template&id=2d94ac9a"
import script from "./ProductLinker.vue?vue&type=script&lang=js"
export * from "./ProductLinker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__